
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/living/contact",
      function () {
        return require("private-next-pages/living/contact.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/living/contact"])
      });
    }
  